import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopularCourseFaqService} from '../../../shared/services/popular-course-faq.service';

@Component({
    selector: 'app-popular-course-faq',
    templateUrl: './popular-course-faq.component.html',
    styleUrls: ['./popular-course-faq.component.scss']
})
export class PopularCourseFaqComponent implements OnInit {
    public question: any;
    public answer: any;
    public popularCourseId: any;
    faqs: any = [];
    submitting: any = false;

    constructor(private activatedRoute: ActivatedRoute,
                private popularCourseFaqService: PopularCourseFaqService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.parent.params['id'];
        this.get();
    }

    get() {
        this.popularCourseFaqService.getByAdmin(this.popularCourseId).subscribe(data => {
            this.faqs = (data && data.length > 0) ? data : [];
        });
    }

    addDetail() {
        const params = {
            question: this.question ? this.question : '',
            answer: this.answer ? this.answer : '',
            sort_order: this.faqs ? this.faqs.length : 0
        };
        this.submitting = true;
        this.popularCourseFaqService.createByAdmin(this.popularCourseId, params).subscribe(data => {
            this.submitting = false;
            this.question = undefined;
            this.answer = undefined;
            this.get();
        }, error => {
            this.submitting = false;
        });
    }

    delete(id) {
        this.popularCourseFaqService.deleteByAdmin(this.popularCourseId, id).subscribe(data => {
            this.get();
        });
    }
}
